import type { Image, ToolMark } from './schema'
import { BOOKING_URL, certification, site } from './site'
import { tools } from './tools'

/**
 * The Home About section: the portrait stands on a hairline floor with the lead over its space; roles
 * with tool logos as raised keys, credentials below. The DISC profile is the certification credential
 * and opens the full profile page.
 */
export const aboutSection = {
  eyebrow: 'About',
  titleThin: "Hi, I'm",
  titleBold: 'Carlo.',
  lede: 'GoHighLevel virtual assistant, based in the Philippines, working with clients in Australia and the US.',
  lead: 'Support roots, systems mindset.',
  leadQuiet: 'I build processes that scale, then keep them running.',
  /** A line under the floor. Optional: leave it out and the section shows none. */
  note: 'I started as a BPO agent in 2014, supporting international companies in customer service and technical support. In 2022 I moved into virtual assistance and found what I love most: systems, automation and helping businesses run more smoothly.',
  picture: {
    src: '/images/profile/carlo.webp',
    srcSet: '/images/profile/480/carlo.webp 480w, /images/profile/carlo.webp 800w',
    alt: `Portrait of ${site.name}`,
    width: 800,
    height: 800,
  } satisfies Image,
}

export const capabilities: { title: string; tools: ToolMark[] }[] = [
  { title: 'HighLevel expert', tools: [tools.gohighlevel, tools.pipelines, tools.calendars] },
  { title: 'Automation expert', tools: [tools.workflows, tools.aiAutomation, tools.emailSms] },
  { title: 'Voice AI support specialist', tools: [tools.voiceAi, tools.whatsapp, tools.aiAutomation] },
  { title: 'Client success manager', tools: [tools.googleWorkspace, tools.emailSms, tools.calendars] },
]

export type AboutCredential = {
  id: 'cert' | 'place' | 'book'
  title: string
  detail: string
  image?: Image
  /** A dark-theme version of the mark, when the light one would vanish on a dark ground (or the reverse). */
  imageDark?: Image
  href?: string
}

export const credentials: AboutCredential[] = [
  { id: 'cert', title: certification.title, detail: certification.detail, href: certification.href, image: { ...certification.image!, alt: '' } },
  { id: 'place', title: site.location, detail: 'Working with AU and US clients' },
  {
    id: 'book',
    title: 'Book a call with me',
    detail: 'Pick a time on my calendar',
    href: BOOKING_URL,
    image: { src: '/images/tools/ghl-calendar.svg', alt: '', width: 64, height: 64 },
  },
]
